var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-control',{attrs:{"label":"Border Radius","expand":""}},[_c('slider',{attrs:{"value":_vm.sliderIndex,"values":_vm.borderRadiusValues,"hide-marks":""},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }